import { isPersonaMode, PERSONA_MODE_COOKIE, PersonaMode } from '@features/navigation/personaMode';

const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // 1 year

// Client-side read/write of the persona-mode cookie. The cookie (not localStorage)
// is used so the middleware and server components can resolve the mode for the
// org-root redirect without a client round-trip.
export const readPersonaModeCookie = (): PersonaMode | undefined => {
  if (typeof document === 'undefined') {
    return undefined;
  }
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${PERSONA_MODE_COOKIE}=`));
  const value = match?.split('=')[1];
  return isPersonaMode(value) ? value : undefined;
};

export const writePersonaModeCookie = (mode: PersonaMode) => {
  document.cookie = `${PERSONA_MODE_COOKIE}=${mode}; path=/; max-age=${COOKIE_MAX_AGE_SECONDS}; samesite=lax`;
};
